import { useTranslation } from "react-i18next";
import Svgs from "assets/svgs";
import "./AccountInfoBox.css";

export type AccountInfoProvider = "EMAIL" | "NAVER" | "KAKAO" | "GOOGLE" | "APPLE" | "LINE" | string;

interface Props {
    /** 가입 provider (EMAIL / NAVER / KAKAO / GOOGLE / APPLE / LINE) */
    provider: AccountInfoProvider;
    /** 마스킹된 이메일 (없으면 provider 명을 primary text 로 표시) */
    email?: string;
    /** 가입일 (ISO date string) — 표시 시 주의 색(--warning) */
    signedUpDate?: string;
}

/**
 * 가입 정보 표시 박스
 *  - SignUp Step7 (이미 가입된 계정 안내)
 *  - Recover Step4 (찾은 계정 결과 표시)
 *
 * SNS provider 면 좌측에 brand 아이콘. EMAIL 이면 아이콘 없음.
 * email 우선 표시, 없으면 provider 명 표시 (SNS 케이스에서 providerEmail 이 null 일 때).
 */
export const AccountInfoBox = ({ provider, email, signedUpDate }: Props) => {
    const { t } = useTranslation();

    const renderSnsIcon = () => {
        if (provider === "EMAIL") return null;
        let bg: string | undefined;
        let icon;
        switch (provider) {
            case "NAVER":
                bg = "#03A94D"; icon = <Svgs.IcSocialNaver />; break;
            case "KAKAO":
                bg = "#fee500"; icon = <Svgs.IcSocialKakao />; break;
            case "GOOGLE":
                bg = "var(--fixedWhite)"; icon = <Svgs.IcSocialGoogle />; break;
            case "APPLE":
                bg = "#000"; icon = <Svgs.IcSocialApple />; break;
            case "LINE":
                bg = "#06C755"; icon = <Svgs.IcSocialLine />; break;
            default:
                return null;
        }
        return (
            <div className="account-info-sns" style={{ backgroundColor: bg }}>
                {icon}
            </div>
        );
    };

    let dateText: string | null = null;
    if (signedUpDate) {
        const d = new Date(signedUpDate);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        dateText = t("signUp.step7.signedUpDate", { year, month, day });
    }

    // email 우선, 없으면 SNS provider 명 표시
    const primaryText = email || (provider !== "EMAIL" ? t(provider) : "");

    return (
        <div className="account-info-box">
            {renderSnsIcon()}
            <div className="account-info-text">
                <span className="account-info-primary">{primaryText}</span>
                {dateText && <span className="account-info-secondary">{dateText}</span>}
            </div>
        </div>
    );
};
